<template>
  <v-app dark>
    <LeftNav />
    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container class="fill-height ma-0 pa-0" fluid>
        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
    </v-main>

    <!-- <v-footer app></v-footer> -->
  </v-app>
</template>

<script>
// @ is an alias to /src
import LeftNav from '@/components/leftNav.vue';
import Vue from 'vue';
import { router } from './router';
export default {
  name: 'App',
  components: {
    LeftNav,
  },
  created: function () {
  }
 };
</script>

<style>
  html {
    overflow-y: auto !important;
  }
  .container {
    max-width: 100% !important;
  }
  .theme--dark.v-application {
    background: black !important;
  }

</style>
